export default class Special {
    constructor() {
        this.init();
    }

    init() {
        this.imageModal();
    }

    imageModal() {
        const open = [...document.querySelectorAll(".js-image_open")];
        const close = [...document.querySelectorAll(".js-image_close")];
        const dynamicImage = document.querySelector(".js-dynamicimage");

        open.forEach((el) => {
            el.addEventListener("click", () => {
                const src = el.getAttribute("data-src");
                const img = new Image();
                img.src = src;
                dynamicImage.appendChild(img);
            });
        });

        close.forEach((el) => {
            el.addEventListener("click", () => {
                const children = [...dynamicImage.querySelectorAll("img")];
                children.forEach((child) => dynamicImage.removeChild(child));
            });
        });
    }
}
